
import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../../routes';
import config from '../../config';

import { ToastContainer, notify } from '../../libraries/notifications';

import servicesActions from '../../context/services/actions';
import { isEmptyObject, searchJSON } from '../../libraries/utils';

import LayoutSmall from '../../components/layout/LayoutSmall';
import { Link } from 'react-router-dom';
import { uuidv4 } from '../../libraries/utils';
import Icon from '../../libraries/icons';

class BookingType extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
    }
  }
  
  componentDidMount() {
  }

  gotoBack = () => {
    const { location } = this.state;
  }

  render() {
    return (
      <LayoutSmall
        main={{ className: ""}}
        header={{
          title: this.t("Tipo de consulta"),
          className: "bg-primary",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="w-full max-w-lg mx-auto p-4 mt-3">
          <label htmlFor="" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            {this.t("Tipo de consulta")}
          </label>


        </section>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
  };
};

const mapDispatchToProps = dispatch => {
  return {
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(BookingType));

